import { AuthState, AuthActionTypes, AuthCreateAction } from "../../types/auth/auth";

const initialState: AuthState = {
    authData: null,
    loading: false,
    authDataError: null,
};

export const authReducer = (
    state = initialState,
    action: AuthCreateAction,
): AuthState => {
    switch (action.type) {
        case AuthActionTypes.FETCH_AUTH_DATA:
            return { ...state, loading: true, authDataError: null, authData: null };

        case AuthActionTypes.FETCH_AUTH_DATA_SUCCESS:
            return { ...state, loading: false, authDataError: null, authData: action.payload };

        case AuthActionTypes.FETCH_AUTH_DATA_ERROR:
            return { ...state, loading: false, authDataError: action.payload, authData: null };
        case AuthActionTypes.CLEAR_AUTH_DATA:
            return { ...state, loading: false, authDataError: null, authData: null };

        default:
            return state;
    }
};